const lgImageSize = {
    get() {
        return 1100;
    },
};
export default lgImageSize;
